import React from 'react';

const EscapeWrapper = (WrappedComponent) => {
	class Wrapper extends React.Component {
		constructor(props) {
			super(props);
			this.child = React.createRef();
		}

		componentDidMount(){
			document.addEventListener( 'keydown', this.onKeyPress, false );
		}

		componentWillUnmount(){
			document.removeEventListener( 'keydown', this.onKeyPress, false );
		}

		onKeyPress = (e) => {
			if( e.key === 'Escape' ){
				this.child.current.props.onClose();
			}
		}

		render() {
			return (
				<WrappedComponent ref={this.child} {...this.props} />
			);
		}
	}
		
	return Wrapper; 
}

export default EscapeWrapper;